// extracted by mini-css-extract-plugin
export default {"calculation-table":"CalculationTable_calculation-table__Oznjr"};